import mitt, { Emitter } from 'mitt';

type Events = {
  triggerClose: string | undefined;
};

export const eventBus: Emitter<Events> = mitt<Events>();
